export function Popup() {
    const $popup = $(".popup");
    const $body = $("body");
    const $popupInfo = $(".popup-info");
    function openPopup($hrefPopup, $videoSrc) {
        $body.addClass("body-lock");
        $popup.addClass("active");
        $($hrefPopup).fadeIn(300);

        if ($($hrefPopup).hasClass("video-popup")) {
            const $videoHolder = $($hrefPopup).find(".video-popup-holder");
            insertVideo($videoHolder, $videoSrc);
        }
    }

    function closePopup() {
        $popup.removeClass("active");
        $body.removeClass("body-lock");
        $popupInfo.fadeOut(200);
        $popupInfo.find("video").remove();
        $popupInfo.find("iframe").remove();
        if ($popupInfo.hasClass("bio-updated")) {
            $popupInfo.removeClass("bio-updated");
            $popupInfo.find('.bio-popup-container').html('')
        }
        if ($popupInfo.hasClass('card-updated')) {
            $popupInfo.removeClass('card-updated')
            $popupInfo.find('.card-popup-container').html('')
        }
    }

    $(document).on("keydown", function (event) { 
        if (event.keyCode == 27) { 
            closePopup();
        }
    });

    // Class for popup opener
    $(document.body).on("click", ".popup-opener", function (e) {
        e.preventDefault();
        const $hrefPopup = $(this).attr("href");
        const $videoSrc = $(this).data("src");
        openPopup($hrefPopup, $videoSrc);
    });

    // Close popups if clicked on popup overlay
    $(document.body).on("click", ".popup-holder" ,function (e) {
        if (!(e.target != this)) {
            closePopup();
        }
    });

    // Class for closing popups
    $(document.body).on("click",".popup-close",function (e) {
        e.preventDefault();
        closePopup();
    });

    function insertVideo($element, $videoSrc) {
        if (!$element.find("video").length) {
            const $isYoutube = $videoSrc.indexOf("youtube") !== -1;
            const $video = $isYoutube
                ? `<iframe width="100%" height="100vh" src="${$videoSrc}?rel=0&modestbranding=1&autoplay=1&mute=0&showinfo=0autohide=1" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
                : `<video controls autoplay playsinline>
                    <source src='${$videoSrc}' type='video/mp4'>
                </video>`;
            $($element).append($video);
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/popup.js